module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/phone.3980ae30.png";